import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Toolbar from "./Toolbar";
import Sidebar from "./Sidebar";
import myImage from '../boy.png'
import { useNavigate } from "react-router-dom";
import { UserManagementAPI } from "../axios";

const EditProfileSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email address").required("Email is required"),
  password: Yup.string().required("Password is required"),
});

const EditProfile = () => {
  const navigate = useNavigate();
  const adminData = JSON.parse(localStorage.getItem("adminData"));
  
  const [profileImage, setProfileImage] = useState(myImage);
  
  const initialValues = {
    name: adminData ? adminData.name : "",
    email: adminData ? adminData.email : "",
    // password: adminData ? adminData.password : "",
  };

  const handleSubmit = (values) => {
    console.log("Form values:", values);
    UserManagementAPI.edit_admin_user(adminData.id, JSON.stringify(values))
      .then((res) => {
        const updatedAdminData = { ...adminData, ...values };
        localStorage.setItem("adminData", JSON.stringify(updatedAdminData));
        navigate('/dashboard');
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfileImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="main-container">
      <Toolbar />
      <div className="content-container">
        <Sidebar />
        <div className="main-content">
          <div className="management-header">
            <h3>Edit Profile</h3>
            <button type="submit" form="edit-profile-form" className="add-user">Update</button>
          </div>
          <div className="center-wrapper">
            <div className="image-container">
              <img
                src={profileImage}
                alt="Profile"
                style={{
                  width: '250px',
                  height: '250px',
                  borderRadius: '50%',
                  objectFit: 'cover',
                }}
              />
              <label htmlFor="image-upload" className="change-picture">
                <span style={{ cursor: 'pointer' }}> Change Picture </span>
                <input
                  type="file"
                  id="image-upload"
                  accept="image/*"
                  onChange={handleImageChange}
                  style={{ display: 'none' }}
                />
              </label>
            </div>
            <Formik
              initialValues={initialValues}
              validationSchema={EditProfileSchema}
              onSubmit={handleSubmit}
            >
              {() => (
                <Form id="edit-profile-form" className="edit-container">
                  <span>Username</span>
                  <div className="profile-edit">
                    <Field name="name" type="text" placeholder={initialValues.name} />
                  </div>
                  <ErrorMessage name="name" component="div" className="error" style={{ marginTop: '-15px', marginLeft: '0px' }} />
                  <span>Email</span>
                  <div className="profile-edit">
                    <Field name="email" type="email" placeholder={initialValues.email} />
                  </div>
                  <ErrorMessage name="email" component="div" className="error" style={{ marginTop: '-15px', marginLeft: '0px' }} />
                  <ErrorMessage name="password" component="div" className="error" style={{ marginTop: '-15px', marginLeft: '0px' }} />
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProfile;
